/**
 * Nesse arquivo vamos criar algumas funções e constantes para definir campos obrigatórios
 * na compra com base no ERP utilizado.
 *
 * Isso será substituido futuramente por uma API que irá retornar essas informações.
 *
 * por enquanto vamos criar um mock para simular essa API, mas com os valores reais.
 * No futuro, podemos substituir esse arquivo pelas requests diretamente.
 */

const ERP_CAMPOS_OBRIGATORIOS_MAP = {
  SANKHYA: {
    campos: ['modoPagamento'],
  },
  M8: {
    campos: ['modoPagamento'],
  },
  PROJEDATA: {
    campos: ['modoPagamento', 'transportadora', 'tipoNotaEntrada'],
    camposItens: ['tipoNotaEntrada'],
  },
  SENIOR_TEIXEIRA: {
    campos: ['modoPagamento', 'centroCusto'],
    camposItens: ['centroCusto'],
  },
  NEO: {
    campos: ['tipoNotaEntrada'],
    camposItens: ['tipoNotaEntrada'],
  },
  TOTVS: {
    campos: ['modoPagamento'],
  },
  LM: {
    campos: ['modoPagamento'],
  },
  USEALL: {
    campos: ['modoPagamento'],
  },
};

/**
 * Retorna uma promise para simular uma request e ficar mais fácil de lidar com isso depois
 * @param erpCamposIntegracao
 * @returns {Promise<Awaited<*>|Awaited<null>>}
 */
const getCamposObrigatorios = async (erpCamposIntegracao) => {
  const camposObrigatorios = ERP_CAMPOS_OBRIGATORIOS_MAP[erpCamposIntegracao];
  if (!camposObrigatorios) {
    return Promise.resolve(null);
  }
  return Promise.resolve(camposObrigatorios);
};

export default {
  getCamposObrigatorios,
};
